import React, { FunctionComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Routes } from '../../common/enums/Routes';
import logo from '../../assets/images/kodiak-logo.svg';
import ImageWrapper from '../ImageWrapper';

const Logo: FunctionComponent<RouteComponentProps> = ({ history }) => (
  <div
    onClick={() => history.push(Routes.Dashboard)}
    role="presentation"
    className="cursor-pointer d-flex align-items-center"
  >
    <ImageWrapper width="7rem" height="1.25rem" src={logo} />
  </div>
);

export default withRouter(Logo);
